<div>
  <!-- Message Switch -->
  <div class="w-100 flex-between position-relative">
    <div class="w-100 flex-between">
        <ul class="nav nav-tabs">
            <li [attr.id]="fromPartner.caseId" class="nav-link nav-link-sm ellipsis" [ngClass]="{'active font-weight-bold': messageTo == fromPartner.caseId}" *ngIf="fromPartner" (click)="messageTo = fromPartner.caseId;getPartnerMessages(fromPartner.caseId)">
              <div class="d-flex align-items-center">
                <div class="" [ngClass]="{'badge badge-primary mr-1':!!partnerById[fromPartner.caseId] && !!partnerById[fromPartner.caseId].badge}"><span *ngIf="!!partnerById[fromPartner.caseId] && !!partnerById[fromPartner.caseId].badge">{{ partnerById[fromPartner.caseId].badge }}</span></div>
                <div class="ellipsis">{{ fromPartner.companyName }}</div>
              </div>
            </li>
            <li class="nav-link nav-link-sm ellipsis" [ngClass]="{'active font-weight-bold': messageTo == 'customer'}" (click)="messageTo = 'customer';clearFilters()">{{ 'Standard.Customer' | translate }}</li>
            <li class="nav-link nav-link-sm ellipsis" [ngClass]="{'active font-weight-bold': messageTo == 'internal'}" (click)="messageTo = 'internal';clearFilters()">{{ 'Packages.Internal' | translate }}</li>
            <li [attr.id]="x.caseId" class="nav-link nav-link-sm ellipsis" *ngFor="let x of toPartners" [ngClass]="{'active font-weight-bold': messageTo == x.caseId }" (click)="messageTo = x.caseId; getPartnerMessages(x.caseId)">
              <div class="d-flex align-items-center">
                <div class="" [ngClass]="{'badge badge-primary mr-1':!!partnerById[x.caseId] && !!partnerById[x.caseId].badge}"><span *ngIf="!!partnerById[x.caseId] && !!partnerById[x.caseId].badge">{{ partnerById[x.caseId].badge }}</span></div>
                <div class="ellipsis">{{ x.companyName }}</div>
              </div>
            </li>
        </ul>
        <div class="d-flex align-items-end mb-auto">
          <div class="mr-2 text-primary" *ngIf="messageTo == 'customer' && !!notifications.sets && case.disableNotifications == null" title="{{ 'Notifications.ChangeNotificationsSet' | translate }}" (click)="delayOpen('notificationSets')"><span><i class="fa-solid fa-pencil"></i></span></div>
          <label class="switch" *ngIf="messageTo == 'customer'" [title]=" ('Notifications.CustomerMessages' | translate) + ' ' + ( case.disableNotifications == null ? (( 'Standard.On' | translate ) | lowercase) : (( 'Standard.Off' | translate) | lowercase) )">
            <input type="checkbox" [checked]="case.disableNotifications == null" (change)="toggleNotifications()">
            <span class="slider round"></span>
          </label>
        </div>
    </div>
    <div class="notificationSets position-absolute" *ngIf="!!notifications.showSets">
      <div *ngFor="let x of notifications.sets" [ngClass]="{'bg-primary text-white' : case.notificationSetId == x.id}" (click)="updateNotificationSetId(x.id)">{{ x.name }}</div>
    </div>
  </div>
  <!-- New Message -->
  <div class="d-flex justify-content-between position-relative">
      <div class="newMessage position-relative mr-2" [ngClass]="{'disabled':messageTo == 'customer' && (!!validation && !validation.current || !!case.disableNotifications),'fileHover':fileHover}">
          <div class="customTextarea" 
              name="messageInput"
              id="newMessageText" 
              spellcheck="true" 
              (focus)="autoSizeTextInput($event);listen($event)" 
              (blur)="dontListen($event)"
              style="overflow-y:auto"
              appImageDropper 
              [ngClass]="{'internal': messageTo == 'internal'}"
              (imgDrop)="imgDrop($event)" 
              (imgHov)="fileHover = $event"
              contenteditable="true"
              ></div>
          <div class="d-flex flex-column position-absolute" style="top: .2rem; right: 0;">
            <div class="messageIcon cursor-pointer text-secondary mr-1" (click)="getStandardTexts()" title="{{ 'Standard.StandardTexts' | translate }}"><i class="fa-regular fa-comment-text fa-2x"></i></div>
            <div class="messageIcon cursor-pointer text-secondary mr-1" *ngIf="messageTo != 'internal'"(click)="fileUploaderInput.click()" title="{{ 'Buttons.AttachFile' | translate }}"><i class="fas fa-paperclip fa-2x"></i></div>
          </div>
      </div>
      <div class="sendSpace">
        <button 
          class="sendButton" 
          style="padding-top: 0.3rem!important;" 
          [disabled]="!message.content.text.trim() || (messageTo == 'customer' && (!!validation && !validation.current || !!case.disableNotifications))" 
          [ngClass]="!message.content.text.trim() || (messageTo == 'customer' && (!!validation && !validation.current || !!case.disableNotifications)) ? 'text-muted cursor-na' : messageTo != 'internal' ? 'text-primary cursor-pointer' : 'text-warning cursor pointer'"
          (click)="resendMessageText == undefined; sendMessage()"><i class="fa-solid fa-paper-plane-top fa-2x"></i>
        </button>
      </div>
      <div class="standardTexts position-absolute"*ngIf="message.showStandardTexts && !!message.standardTexts">
        <div class="w-100" *ngFor="let x of message.standardTexts" (click)="addStandardText(x)">
          <b>{{ x.header }}</b>
          <p class="maxOneLine">{{ (x.content.length > 100) ? (x.content | slice:0:100) + '...' : x.content }}</p>
        </div>
      </div>
  </div>
  <div class="d-flex justify-content-between">
    <div>
      <div *ngIf="taggableUsers.length > 0">
        <span class="badge badge-primary cursor-pointer mr-1" (click)="tagUser(x)" *ngFor="let x of taggableUsers">
          {{ x.name }}
        </span>
      </div>
    </div>
    <div class="d-flex justify-content-end" *ngIf="!!userTagList && userTagList.length > 0">
      <div *ngFor="let x of userTagList" class="badge badge-primary cursor-pointer ml-1" (click)="removeTag(x)">
        {{ x.name }}<i class="fas fa-times ml-2"></i>
      </div>
    </div>
  </div>
  
  <!-- Files to be sent with message -->
  <div class="w-100 messageFiles" *ngIf="!!message.content.files && message.content.files.length > 0">
    <div class="col-3 col-lg-2 attachmentContainer" *ngFor="let f of message.content.files; let i = index" (click)="message.removeFile(i)" title="{{f.fileName}}">
      <div class="uploadContainer h-100">
        <img class="img-fluid p-1 uploads" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ f.fileId }}" alt="image" *ngIf="f.ext != 'heic' && f.ext != 'pdf'" />
        <img class="img-fluid p-1 uploads" src="../../../assets/img/icons/pdfIcon.png" *ngIf="f.ext == 'pdf'" alt="pdf" />
        <app-img-heic [fileId]="f.fileId" [class]="'img-fluid p-1 uploads'" *ngIf="f.ext == 'heic'"></app-img-heic>
      </div>
      <i class="fas fa-times-circle circle-img"></i>
    </div>
  </div>
  <!-- If message can't be sent because notification reciever has no email or mobile -->
  <div class="w-100" *ngIf="messageTo == 'customer' && !!validation && !validation.current">
    <div class="mt-1 mb-1 font-weight-bold">{{'Delivery.Notice' | translate}}</div>
    <div class="notificationRecieverChange d-flex">
      <div class="mr-3">{{ 'Standard.ChangeTo' | translate }}: </div>
      <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="validation.invoice" (click)="switchNotificationReciever('invoice', false)">{{'Word.Invoice' | translate}}</div>
      <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="validation.customer" (click)="switchNotificationReciever('customer', false)">{{'Standard.Customer' | translate}}</div>
      <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="validation.delivery" (click)="switchNotificationReciever('delivery', false)">{{'Standard.Delivery' | translate}}</div>
      <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="validation.contact" (click)="switchNotificationReciever('contact', false)">{{'Standard.Contact' | translate}}</div>
    </div>
  </div>
  <!-- Message Filter Bar -->
  <div class="input-group input-group-sm mt-3" style="margin-bottom:-1px;">
    <div class="input-group-prepend"><i class="input-group-text input-group-text-sm fa-solid fa-magnifying-glass" style="border-bottom-left-radius:0"></i></div>
    <input class="form-control form-control-sm" type="text" [(ngModel)]="message.filterString" (keyup)="filterMessages()">
    <div class="input-group-append" (click)="clearFilters()"><span class="input-group-text input-group-text-sm" style="border-bottom-right-radius:0">x</span></div>
    <div class="input-group-append" (click)="filterInternals = !filterInternals;filterMessages()" *ngIf="messageTo == 'customer'" title="{{ 'Word.Filter' | translate }} {{ ('Buttons.SendInternalMessage' | translate) | lowercase }}">
      <span class="pdfMaker" *ngIf="filterInternals"><i class="fa-thin fa-user-helmet-safety fa-2x"></i></span>
      <span class="pdfMaker" *ngIf="!filterInternals"><i class="fa-solid fa-user-helmet-safety fa-2x"></i></span>
    </div>
    <div class="input-group-append"><span class="pdfMaker" (click)="makePrintable()"><i class="fa-solid fa-file-pdf fa-2x"></i></span></div>
  </div>
    
    <!-- Messages -->
  <div class="w-100" id="CaseMessageHolder">
    <!-- Pending Messages -->
    <div class="message system pendingMessage" *ngFor="let x of filteredPendingMessages" [attr.id]="x.id" [ngClass]="{'open':x.open}">
      <div class="w-100 d-flex justify-content-between cursor-pointer" (click)="x.open = !x.open">
        <div class="sender-name" [ngClass]="x.sending ? '' : 'strikeOut'">{{ type.notificationTypeTranslate(x.notificationTypeId) | translate }}</div>
        <div class="d-flex text-end">
          <div class="mr-3">
            <span class="badge badge-secondary mr-3 ml-3" *ngIf="x.sending">{{ 'Standard.PendingMessage' | translate }}</span>
            <span class="badge badge-warning mr-3 ml-3" *ngIf="!x.sending">{{ 'Offers.Rejected' | translate }}</span>
          </div>
          <p class="timestamp-text" [ngClass]="x.sending ? '' : 'strikeOut'" *ngIf="x.notificationTypeId == 'd0ff8ebc-6b01-4cfc-90fd-1614d92d4ceb'">{{ x.sendingAt | date:'dd-MM-YYYY'}} 09:00</p>
          <p class="timestamp-text" [ngClass]="x.sending ? '' : 'strikeOut'" *ngIf="x.notificationTypeId != 'd0ff8ebc-6b01-4cfc-90fd-1614d92d4ceb'">{{ x.sendingAt | date:'dd-MM-YYYY HH:mm'}}</p>
        </div>
      </div>
      <div class="w-100 text-center d-flex justify-content-around mt-3">
        <div>
          <label class="mb-1">{{ 'Standard.Date' | translate }}</label>
          <input type="date" class="form-control form-control-sm p-1" [(ngModel)]="x.date">
        </div>
        <div *ngIf="x.notificationTypeId != 'd0ff8ebc-6b01-4cfc-90fd-1614d92d4ceb'">
          <label class="mb-1">{{ 'Standard.Time' | translate }}</label>
          <input type="time" class="form-control form-control-sm p-1" [(ngModel)]="x.time">
        </div>
      </div>
      <div class="w-100 mt-3">
        {{ 'OfferDetails.ResponseToCustomer' | translate }}:<br />
        <div class="pendingSMS mt-3" [innerHtml]="x.sms"></div>
      </div>
      <div class="w-100 flex-around mt-3 mb-3">
        <button type="button" class="btn btn-sm btn-danger" (click)="pendingToggle(x)">{{ 'Buttons.Reject' | translate }}</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="editPendingMessage(x)">{{ 'Buttons.Save' | translate }}</button>
      </div>
    </div>
    <div *ngFor="let x of filteredMessages" class="message {{ !!x.type ? x.type : x.messageTypeId == '758a738b-e5db-4169-b1b8-63b6fdeff9b7' ? 'customer' : '' }}" [attr.id]="x.messageId">
      <!-- Message Header -->
      <div class="w-100 d-flex justify-content-between">
        <!-- Message Sender Name -->
        <div class="sender-name">
          <div *ngIf="!!x.sender">{{ x.sender }}</div>
          <div *ngIf="!x.sender && x.messageTypeId != '758a738b-e5db-4169-b1b8-63b6fdeff9b7'">{{ x.type == 'system' || x.type == 'partner' ? ( 'Standard.System' | translate ) : x.type == 'offerAccept' ? ('Notifications.OfferAccepted' | translate) : '' }}</div>
          <div *ngIf="x.messageTypeId == '758a738b-e5db-4169-b1b8-63b6fdeff9b7'">{{ x.sentByCustomer.name }}</div>
          <div class="text-muted" *ngIf="x.type == 'internal'">{{ 'Buttons.SendInternalMessage' | translate }}</div>
        </div>
        <!-- Date and Menu -->
        <div class="text-right message-data d-flex flex-column align-items-end">
          <p class="timestamp-text">{{ (x.sentAt) ? ( x.sentAt + 'Z' | date:'dd-MM-YYYY HH:mm') : '' }} <span class="messageMenuButton cursor-pointer ml-2 mr-1" (click)="x.showMenu = true"><i class="fas fa-ellipsis-v"></i></span></p>
          <div *ngIf="!['customer','internal', undefined].includes(x.type)">
            <span *ngIf="x.emailSent && x.type != 'systemInternal' && x.type != 'internal'">
              <span *ngIf="!!x.receiverMail" title="{{ ('Standard.EmailSent' | translate) + ' ' + x.receiverMail + (x.messageReadByCustomer ? '.\n'+ ('Messages.LastReadByCustomer' | translate) + ' ' + ((x.messageReadAt) ? (x.messageReadAt + 'Z' | date:'dd-MM HH:mm') : ''): '') }}">
                <i class="far fa-envelope text-primary" *ngIf="!x.messageReadByCustomer"></i>
                <i class="far fa-envelope-open text-primary" *ngIf="x.messageReadByCustomer"></i>
              </span>
              <span *ngIf="!['system'].includes(x.type) && !x.receiverMail" title="{{ 'Standard.EmailMissing' | translate }}">
                <i class="far fa-envelope text-danger"></i>
              </span>
            </span>
            <span *ngIf="x.smsSent && x.type != 'systemInternal' && x.type != 'internal'" class="ml-1">
              <span *ngIf="!!x.receiverMobile" title="{{ ('Standard.SmsSent' | translate) + ' ' + x.receiverMobile + ( x.messageReadByCustomer ? '.\n'+ ('Messages.LastReadByCustomer' | translate) + ' ' + ((x.messageReadAt) ? (x.messageReadAt + 'Z' | date:'dd-MM HH:mm') : '') : '' ) }}">
                <i class="fas fa-mobile-alt text-primary" *ngIf="!x.messageReadByCustomer"></i>
                <i class="fas fa-mobile-alt text-primary" *ngIf="x.messageReadByCustomer"></i>
              </span>
              <span *ngIf="!x.receiverMobile" title="{{ 'Standard.MobileMissing' | translate }}">
                <i class="fas fa-mobile-alt text-danger"></i>
              </span>
            </span>
            <span *ngIf="!x.smsSent && !x.emailSent && !x.type == 'toPartner'" class="ml-1">
              <span title="{{ 'Standard.NotSent' | translate }}">
                <i class="far fa-envelope text-secondary"></i>
              </span>
            </span>
          </div>
          <!-- Message Menu -->
          <ul class="list-group messageMenu cursor-pointer" *ngIf="x.showMenu">
            <li class="list-group-item list-group-item-action messageMenuHeader p-1" (click)="x.showMenu = false">{{ 'Buttons.Close' | translate }}</li>
            <li class="list-group-item list-group-item-action messageMenuHeader p-1" (click)="markAsUnread(x.messageId);x.showMenu = false" *ngIf="!!x.sentByCustomer && !!x.sentByCustomer.name">{{ 'Buttons.MarkAsUnread' | translate }}</li>
            <li class="list-group-item list-group-item-action messageMenuHeader p-1" (click)="resendMessage(x); x.showMenu = false" data-toggle="modal" data-target="#ResendMessage">{{'Standard.Resend' | translate}}</li>
            <li class="list-group-item list-group-item-action messageMenuHeader p-1" (click)="message.prepareMessageToPartner(x);x.showMenu = false" data-toggle="modal" data-target="#forwardMessageToPartner" *ngIf="hasPartners">{{ 'Standard.ForwardToPartner' | translate }}</li>
          </ul>
        </div>
      </div>
      <!-- Message Includes Title -->
      <div class="w-100" *ngIf="!!x.title">
        <h4 *ngIf="x.title != '-'">{{ x.title }}</h4>
        <h4 *ngIf="x.messageTypeId == 'WithNetPromoterScoreIsVoted'">{{ 'Ratings.Rating' | translate }}: {{ x.description.split('$')[0] }}</h4>
      </div>
      <!-- Message Content -->
      <div class="w-100">
        <!-- Short Description Message -->
        <div class="shortDescription" *ngIf="!!x.shortDescription" [innerHTML]="x.shortDescription"></div>
        <!-- Long Description Message -->
        <div class="description" *ngIf="!x.shortDescription && !message.hasSpecialMessage(x)" [innerHTML]="x.description"></div>
        <!-- Special Messages -->
        <div *ngIf="x.type == 'offerAccept'">{{ 'Offer.OfferAcceptedByCustomerMessage' | translate }}</div>
        <div *ngIf="message.hasSpecialMessage && x.messageTypeId == '77e3ae35-6955-4fbb-89a9-1992ee407dd6'">
          <div class="font-weight-bold" style="font-size:1rem;">{{ 'Ratings.Rating' | translate }}</div>
          <br />
          <div class="rated d-flex align-items-center">
            <div class="text-center rating {{ message.getRatingStyle(x.description) }}">
              {{ message.getRating(x.description) }}
            </div>
            <div class="ratingComment ml-5">{{ 'Standard.Comment' | translate }}: {{ message.getRatingMessage(x.description) }}</div>
          </div>
          <br />
        </div>
        <span *ngIf="x.messageTypeId == 'f92ed551-b7f5-49f8-8d76-e35fcefe33cd'">{{ 'Word.By' | translate }} {{x.sentBy.name}}</span>
      </div>
      <!-- Message Files -->
      <div class="w-100" *ngIf="!!x.fileId && x.fileId.length > 0">
        <div class="messageFileHeader" (click)="displayFiles(x)">{{ !x.showFiles ? ('Standard.Show' | translate) : ('Standard.Hide' | translate) }} {{ 'Standard.Files' | translate }} ({{ x.fileId.length }})</div>
        <div class="messageFileContent" [ngStyle]="{'height': !x.showFiles ? '0rem' : getFileHeight(x) }">
          <div *ngIf="x.fileId.length != x.files.length"><i class="fas fa-spinner fa-spin"></i></div>
          <div class="fileContainer" *ngIf="x.files.length > 0">
            <app-image-viewer [images]="x.files" [options]="{'upload':false, hideOptions:true}"></app-image-viewer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  <!-- Forward message to partner -->
<div id="forwardMessageToPartner" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title">{{ 'Standard.MessageToPartner' | translate }}</h5>
        <button class="close" data-dismiss="modal"><span>x</span></button>
      </div>
      <div class="modal-body p-3" *ngIf="hasPartners">
        <div class="form-group">
          <label for="partnerSelectDropdown">{{ 'Buttons.SendMessageToPartner' | translate }}</label>
          <select class="form-control" id="partnerSelectDropdown" [(ngModel)]="messageTo" (change)="filterMessages()">
            <option value="{{fromPartner.caseId}}" *ngIf="fromPartner">{{ fromPartner.companyName }}</option>
            <option *ngFor="let x of toPartners" value="{{ x.caseId }}">{{ x.companyName }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="messageToPartnerText">{{ 'Standard.Message' | translate }}</label>
          <textarea class="form-control form-control-sm message-input" id="forwardMessageToPartnerText" rows="2" (keyup)="autogrow($event)" spellcheck="true"></textarea>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button class="btn btn-sm btn-primary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        <button class="btn btn-sm btn-success" data-dismiss="modal" (click)="sendMessageToPartner()" [disabled]="messageTo == 'customer' || messageTo == 'internal'">{{ 'Buttons.SendMessage' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div id="forwardMessageToPartner" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title">{{ 'Standard.MessageToPartner' | translate }}</h5>
        <button class="close" data-dismiss="modal"><span>x</span></button>
      </div>
      <div class="modal-body p-3" *ngIf="hasPartners">
        <div class="form-group">
          <label for="partnerSelectDropdown">{{ 'Buttons.SendMessageToPartner' | translate }}</label>
          <select class="form-control" id="partnerSelectDropdown" [(ngModel)]="messageTo" (change)="filterMessages()">
            <option value="{{fromPartner.caseId}}" *ngIf="fromPartner">{{ fromPartner.companyName }}</option>
            <option *ngFor="let x of toPartners" value="{{ x.caseId }}">{{ x.companyName }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="messageToPartnerText">{{ 'Standard.Message' | translate }}</label>
          <textarea class="form-control form-control-sm message-input" id="forwardMessageToPartnerText" rows="2" (keyup)="autogrow($event)" spellcheck="true"></textarea>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button class="btn btn-sm btn-primary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        <button class="btn btn-sm btn-success" data-dismiss="modal" (click)="sendMessageToPartner()" [disabled]="messageTo == 'customer' || messageTo == 'internal'">{{ 'Buttons.SendMessage' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!--Resend message to someone else-->
<div class="modal fade" id="ResendMessage" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title">{{ 'Standard.ResendMessage' | translate }}</h5>
        <button class="close" data-dismiss="modal"><span>x</span></button>
      </div>
      <div class="modal-body p-3">
        <div class="form-group">
          <textarea class="form-control form-control-sm message-input" id="resendMessageText" [(ngModel)]="resendMessageText" rows="2"></textarea>
        </div> <hr />
        <span>{{'Standard.ChangeAndResend' | translate}}: </span>
        <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="!!validation && validation.invoice" data-dismiss="modal" (click)="switchNotificationReciever('invoice', true)">{{'Word.Invoice' | translate}}</div>
        <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="!!validation && validation.customer" data-dismiss="modal" (click)="switchNotificationReciever('customer', true)">{{'Standard.Customer' | translate}}</div>
        <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="!!validation && validation.delivery" data-dismiss="modal" (click)="switchNotificationReciever('delivery', true)">{{'Standard.Delivery' | translate}}</div>
        <div class="badge badge-primary p-1 mr-2 cursor-pointer" *ngIf="!!validation && validation.contact" data-dismiss="modal" (click)="switchNotificationReciever('contact', true)">{{'Standard.Contact' | translate}}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

  <input #fileUploaderInput type="file" hidden (click)="$event.target.value = ''" multiple (change)="imgDrop($event.target.files)" />
